import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { LanguageLoader } from '../load-language';
import { EnvService } from '../services/env.service';
import { UniversalStorageService } from '../services/universal-storage.service'; 


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        HttpClientModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en-GB', // Provide a default language (will be used in SSR)
             useDefaultLang: true,
            
            loader: {
                provide: TranslateLoader,
                useClass: LanguageLoader,
                deps: [HttpClient, EnvService],
            },
        }),

    ],
    exports: [TranslateModule],
    providers: [
        {
          provide: TranslateLoader,
          useClass: LanguageLoader,
          deps: [HttpClient, EnvService],
        },
        {
          provide: 'defaultLanguage',
          useFactory: (storageService: UniversalStorageService) => {
            return storageService.getDefaultLanguage();
          },
          deps: [UniversalStorageService],
        },
      ],
})
export class NgxTranslateModule { }
